import React, { memo } from 'react';
import { sanitizeToDate, useCurrentTime } from '@/util/timerHooks';

interface ReadyForPreOpTimerProps {
  since?: Date | string | number | null;
}

const ReadyForPreOpTimer = memo(function ReadyForPreOpTimer({ since }: ReadyForPreOpTimerProps) {
  const readyAt = since == null ? NaN : (sanitizeToDate(since)?.getTime() ?? NaN);
  const hasReadyTime = Number.isFinite(readyAt);
  const currentTime = useCurrentTime({ precision: 'second', paused: !hasReadyTime });

  if (!hasReadyTime) return null;

  const elapsedSeconds = Math.max(0, Math.floor((currentTime.getTime() - readyAt) / 1000));
  const hours = Math.floor(elapsedSeconds / 3600);
  const minutes = Math.floor(elapsedSeconds / 60) % 60;
  const seconds = elapsedSeconds % 60;
  const duration =
    hours > 0 ? `${hours}h ${String(minutes).padStart(2, '0')}m` : `${minutes}m ${String(seconds).padStart(2, '0')}s`;

  return (
    <span role="timer" aria-label="Time since marked ready for PreOp" style={{ fontVariantNumeric: 'tabular-nums' }}>
      {duration}
    </span>
  );
});

export default ReadyForPreOpTimer;
